import { T } from '@territory/tokens';
import { consoleRole } from './consoleRoles.js';

/*
 * The owner console To-do action button (legacy .tdbtn, with .pri and .quiet), for Button variant="action". Fill, ink and
 * edge live in the sheet, not inline, so hover and disabled can replace them and a caller `style` still wins. Every
 * color is a base token (the legacy --surface2, --border, --text, --accentGlow and the rest are aliases of them); the
 * hover fill reads the act-hover role (legacy --surface3).
 */

/* verbatim legacy .tdbtn, off-scale */
export const ACTION_H = 30;
export const ACTION_H_PHONE = 36;
export const ACTION_PX = 11;
export const ACTION_R = 8;
export const ACTION_FONT = 12.5;
export const ACTION_GAP = 6;
const ACTION_PHONE = '@media (max-width: 760px)';
const ACTION_NARROW = '@media (max-width: 860px)';
const DISABLED_OPACITY = 0.5;

/* Tones: legacy .pri (accent) and .quiet. Neutral is the bare .tdbtn. Legacy hover applies to every tone and out-ranks
   the tone edge and fill; quiet hover also turns the ink to the primary ink. */
export function actionButtonCss(sel: string): string {
  const on = `${sel}:not([aria-disabled]):hover`;
  return `${sel} { min-height: ${ACTION_H}px; background: ${T.surfaceAlt}; color: ${T.label}; border: 1px solid ${T.separator}; box-shadow: none; }
${sel}[data-rv-tone="accent"] { border-color: ${T.accentTint}; background: ${T.accentSoft}; color: ${T.accent}; }
${sel}[data-rv-tone="quiet"] { border-color: transparent; background: none; color: ${T.labelSec}; }
@media (hover: hover) { ${on} { border-color: ${T.separatorBold}; background: ${consoleRole('act-hover', T.surfaceAlt)}; }
${sel}[data-rv-tone="quiet"]:not([aria-disabled]):hover { color: ${T.label}; } }
${sel}:focus-visible { outline: 2px solid ${T.accentTint}; outline-offset: 2px; }
${sel}[aria-disabled] { opacity: ${DISABLED_OPACITY}; cursor: default; }
${ACTION_NARROW} { ${sel}[data-rv-size="dense"] { min-width: 0; min-height: ${ACTION_H}px; } }
${ACTION_PHONE} { ${sel}[data-rv-size="dense"] { min-height: ${ACTION_H_PHONE}px; } }`;
}
